import { tx } from "@/i18n/tx";
import { useState } from "react";
import { createPortal } from "react-dom";
import PaymentChoice, { isPaymentValid } from "@/components/invoices/PaymentChoice";

export default function PaymentDialog({ hints, onConfirm, onCancel }) {
  const [p, setP] = useState(null);
  return createPortal(
    <div className="fixed inset-0 z-[70] bg-black/50 flex items-end sm:items-center justify-center sm:p-6" data-testid="payment-dialog">
      <div className="bg-surface w-full sm:max-w-md rounded-t-3xl sm:rounded-3xl p-5 sm:p-6 space-y-4 shadow-2xl page-enter" style={{ paddingBottom: "calc(env(safe-area-inset-bottom) + 20px)" }}>
        <h3 className="font-display text-2xl">{tx("ui_paymentdialog.k1b91ea")}</h3>
        <PaymentChoice value={p} onChange={setP} hints={hints} testPrefix="payment-dialog" />
        <button type="button" disabled={!isPaymentValid(p)} onClick={() => onConfirm(p)} className="btn-primary w-full" data-testid="payment-dialog-confirm">{tx("ui_paymentdialog.k83d7c4")}</button>
        <button type="button" onClick={onCancel} className="w-full h-11 text-sm font-semibold text-text-secondary" data-testid="payment-dialog-cancel-scan">{tx("ui_paymentdialog.k58e305")}</button>
      </div>
    </div>,
    document.body
  );
}
